export default function getRatio(start, middle, end) {
  return (middle - start) / (end - start)
}
